/*
 * @Description:全局状态管理
 * @Author: Mayer
 * @Date: 2020-03-25 14:39:19
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-11-18 18:01:56
 */
import { createStore, combineReducers } from "redux";

const PHONE = "PHONE";
//定义全局接口类型
interface ReduxState { }
//定义初始化数据
const initData = {
  //国家
  countryList: [],
  countryActive: {
    name: "", // "Nigeria",
    mcc: "", //"621",
  },
  //图片路径
  imgUrl: "",
  //机型
  model: {
    leftName: "", //品牌
    leftCode: "",
    rightName: "", //机型
    rightCode: "",
  },
  keyword: "",
  //问题描述
  problems: "",
  //客户信息
  infoName: "",
  infoPhone: "",
  //店铺信息
  shopMessage: {
    storeName: "",
    storeCode: "",
    storeAddr: "",
  },
  //预约时间
  time: [], //["2020-06-18", "09:00-10:00"]
  everyThingDoFirst: false,//必须点击一下才能使用各项功能
  birthdayInit: false,//生日聚会音乐播放
};
//定义dispatch调用的action
//机型选择
export const chooseModel = (v: any) => {
  return { type: "chooseModel", data: v };
};
//设置关键字
export const setKey = (v: any) => {
  return { type: "setKey", data: v };
};
//问题描述
export const setProblems = (v: any) => {
  return { type: "setProblems", data: v };
};
//banner图片
export const getBannerImg = (v: any) => {
  return { type: "getBannerImg", data: v };
};
//国家列表
export const getCountryList = (v: any) => {
  return { type: "getCountryList", data: v };
};
//选中国家
export const setCountryActive = (v: any) => {
  return { type: "setCountryActive", data: v };
};
//客户姓名
export const setName = (v: any) => {
  return { type: "name", data: v };
};
//客户手机
export const setPhone = (v: any) => {
  return { type: PHONE, data: v };
};
//店铺信息
export const setShop = (v: any) => {
  return { type: "setShop", data: v };
};
//预约时间
export const setTime = (v: any) => {
  return { type: "setTime", data: v };
};
//必须点击一下才能使用各项功能
export const setEveryThingDoFirst = (v: any) => {
  return { type: "setEveryThingDoFirst", data: v };
};
//生日聚会音乐播放
export const setBirthdayInit = (v: any) => {
  return { type: "setBirthdayInit", data: v };
};

//定义action触发state改变
const defaultState = (state: any = initData, action: any) => {
  switch (action.type) {
    case "setShop": //店铺信息
      return { ...state, ...{ shopMessage: action.data } };
    case "setTime": //
      return { ...state, ...{ time: action.data } };
    case "setEveryThingDoFirst": //
      return { ...state, ...{ everyThingDoFirst: action.data } };
    case "setBirthdayInit"://生日聚会音乐播放
      return { ...state, ...{ birthdayInit: action.data } };
    default:
      return state;
  }
};

// 全局你可以创建多个reducer 在这里统一在一起
const defaultStore = combineReducers({ defaultState });
// 全局就管理一个store
export const store = createStore(defaultStore);
